export function json2query(args: Record<string, string | number> = {}) {
  const keys = Object.keys(args);
  let out = '';
  keys.forEach((key) => {
    out += `${out}&${encodeURIComponent(key)}=${encodeURIComponent(args[key])}`;
  });
  return out;
}
